"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _fluture = require("fluture");

// dispatcher :: Dispatch -> Action|Action[] -> IO
var dispatcher = function dispatcher(dispatch) {
  return function (actions) {
    if (!actions) {
      return;
    } // An array of actions was returned


    if (actions.constructor === Array) {
      actions.map(dispatch);
      return;
    } // Just one action was returned


    if (actions.type !== undefined) {
      dispatch(actions);
    }
  };
}; // filterEpic :: Action -> Epic[]|Epic -> Boolean


var filterEpic = function filterEpic(action) {
  return function (epic) {
    return epic.type.constructor === Array ? epic.type.indexOf(action.type) > -1 : epic.type === action.type;
  };
};

var counter = 1;
var cache = {}; // meatball :: Epic[] -> Store -> Next -> Action -> IO

var meatball = function meatball(epics) {
  if (!epics || epics.constructor !== Array) {
    throw new Error('MEATBALL EPICS MUST BE AN ARRAY');
  }

  return function (store) {
    return function (next) {
      return function (action) {
        var result = next(action);
        var postActionState = store.getState();
        var actioner = dispatcher(store.dispatch);
        epics.filter(filterEpic(action)).forEach(function (epic) {
          var unsub = epic.debounce ? (0, _fluture.after)(epic.debounce, '').chain(function () {
            return epic.do(result, postActionState);
          }).fork(actioner, actioner) : epic.do(result, postActionState).fork(actioner, actioner);

          if (epic.latest || epic.debounce) {
            var id = counter++;

            if (cache[epic.type.toString()] && cache[epic.type.toString()].id !== id) {
              cache[epic.type.toString()].unsub();
            }

            cache[epic.type] = {
              id: id,
              unsub: unsub
            };
          }
        });
      };
    };
  };
};

var _default = meatball;
exports.default = _default;